import React from "react";

import {
  Card,
  withTheme,
  CircularProgress,
  withStyles,
  TextField,
  FormControl,
  InputAdornment,
  Checkbox,
  InputLabel,
  FormGroup,
  FormControlLabel,
  Button
} from "@material-ui/core";
import {
  CheckBoxOutlined,
  CheckBoxOutlineBlank,
  ArrowLeftSharp
} from "@material-ui/icons";
import s from "./give.module.css";
import globalContext from "../../context/globalContext";
import {
  Elements,
  StripeProvider,
} from "react-stripe-elements";
import { InjectedCardForm } from "../PaymentMethods";
import config from "../../configuration/config";

class GiveGift extends React.Component {
  static contextType = globalContext;
  constructor(props) {
    super(props);
    this.state = {
      selectedOptionUuid: null,
      showAddNewCard: false,
      email: "",
      username: "",
      amount: 10,
      code: "",
      isAnonymous: false,
      error: {},
      message: "",
      confirmation: null,
      loading: false
    };
  }

  async componentWillMount() {
    await this.context.global.getUserByUuid();

    if (this.context.global.data.user.account.paymentOptions.length > 0) {
      this.setState({
        selectedOptionUuid: this.context.global.data.user.account
          .paymentOptions[0].uuid
      });
    } else {
      this.setState({ showAddNewCard: true });
    }
  }

  handleChange(ev) {
    if (ev.target.name === "email") {
      this.setState({ email: ev.target.value });
    }

    if (ev.target.name === "code") {
      this.setState({ code: ev.target.value });
    }

    if (ev.target.name === "message") {
      this.setState({ message: ev.target.value });
    }

    if (ev.target.name === "amount") {
      this.setState({ amount: ev.target.value });
    }

    if (ev.target.name === "anonymous") {
      this.setState({
        isAnonymous: ev.target.checked
      });
    }
  }

  validate(ev) {
    if (ev.target.name === "email") {
      if (ev.target.value.length <= 0) {
        this.setState({ error: { ...this.state.error, email: "Required" } });
      } else {
        this.setState({ error: { ...this.state.error, email: null } });
      }
    }

    if (ev.target.name === "amount") {
      if (parseFloat(ev.target.value) < 5) {
        this.setState({
          error: { ...this.state.error, amount: "Must be at least $5" }
        });
      } else {
        this.setState({ error: { ...this.state.error, amount: null } });
      }
    }
  }

  selectPaymentOption(pmUuid) {
    this.setState({ selectedOptionUuid: pmUuid });
  }

  async submit() {
    let {
      email,
      message,
      code,
      isAnonymous,
      selectedOptionUuid,
      amount
    } = this.state;

    this.setState({ loading: true });

    let res = await this.context.global.giveGift({
      toEmail: email.includes("@") ? email : undefined,
      toUsername: email.includes("@") ? undefined : email,
      campaignCode: code,
      isAnonymous,
      paymentOptionUuid: selectedOptionUuid,
      message,
      amount: amount * 100
    });

    this.setState({
      confirmation: res.confirmation,
      loading: false
    });
  }

  render() {
    const { theme } = this.props;
    const { user } = this.context.global.data;
    const {
      selectedOptionUuid,
      showAddNewCard,
      email,
      code,
      error,
      amount,
      isAnonymous,
      message,
      confirmation,
      loading
    } = this.state;

    if (!user) {
      return (
        <div>
          <CircularProgress></CircularProgress>
        </div>
      );
    }

    if (confirmation) {
      return (
        <Card className={s.card}>
          <div>
            <h1 style={{ marginBottom: 5, color: "green" }}>Thank you!!!</h1>
            <div>Your gift is appreciated.</div>
            <div style={{ marginBottom: "2rem" }}></div>
            <div className={s.newCardContainerTitle}>Confirmation #</div>
            <div style={{ fontSize: "small" }}>{confirmation}</div>
          </div>
          <div style={{ marginBottom: "2rem" }}></div>
          <div style={{ marginBottom: "2rem" }}></div>
          <Button
            onClick={() => {
              this.props.history.push("/find-hot-spot");
            }}
            fullWidth
          >
            Now get free grocery delivery!
          </Button>
        </Card>
      );
    }

    return (
      <div>
        <Card className={s.card}>
          <div>
            <div
              className={s.cardDescription}
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                textAlign: "left"
              }}
            >
              <div
                style={{
                  border: "3px solid #ccc",
                  borderRadius: 10,
                  width: 30,
                  height: 30,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  marginRight: 5
                }}
                onClick={() => {
                  this.props.history.goBack();
                }}
              >
                <ArrowLeftSharp></ArrowLeftSharp>
              </div>
              Give the Gift of Groceries
            </div>
            <div style={{ fontSize: "smaller", padding: 10 }}>
              Your gift will be automatically credited to the receiver's
              account. If the receiver does not yet have an account, they will
              be notified to create one. Upon registering, your gift will be
              credited to their account.
              <br></br>
              <br></br> Your gift never expires, and can be used wherever
              hotspots and delivery zones are!
            </div>
            <div style={{ display: "flex" }}>
              <FormControl fullWidth style={{ marginTop: 0 }}>
                <TextField
                  name={"email"}
                  placeholder={"email"}
                  value={email}
                  error={error.email}
                  label={"Who gets your gift?"}
                  onChange={this.handleChange.bind(this)}
                  onBlur={this.validate.bind(this)}
                  autoCapitalize="none"
                  autoCorrect="none"
                  margin="normal"
                  required
                  helperText={error.email ? error.email : "email or username"}
                />
                <TextField
                  name={"code"}
                  placeholder={"campaign code"}
                  value={code}
                  error={error.code}
                  label={"Gift Campaign code"}
                  onChange={this.handleChange.bind(this)}
                  onBlur={this.validate.bind(this)}
                  autoCapitalize="none"
                  autoCorrect="none"
                  margin="normal"
                />

                <TextField
                  name={"message"}
                  placeholder={"Message"}
                  value={message}
                  label={"Message"}
                  onChange={this.handleChange.bind(this)}
                  onBlur={this.validate.bind(this)}
                  autoCapitalize="none"
                  autoCorrect="none"
                  margin="normal"
                  multiline
                />

                <TextField
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">$</InputAdornment>
                    )
                  }}
                  id="amount"
                  name={"amount"}
                  style={{ marginTop: "1.5rem" }}
                  placeholder={"amount"}
                  value={amount}
                  error={error.amount}
                  label={"Amount"}
                  onChange={this.handleChange.bind(this)}
                  onBlur={this.validate.bind(this)}
                  autoCapitalize="none"
                  autoCorrect="none"
                  required
                  type="number"
                  helperText={error.amount ? error.amount : ""}
                />

                <FormGroup style={{ marginTop: "1rem" }}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        name="anonymous"
                        checked={isAnonymous}
                        onChange={this.handleChange.bind(this)}
                        value={"true"}
                      />
                    }
                    label="Send Anonymously"
                  />
                </FormGroup>
              </FormControl>
            </div>
            <div>
              <InputLabel>Credit Card Information</InputLabel>
              <div style={{ marginTop: "1rem" }} />
              {user.account.paymentOptions.map(pm => {
                return (
                  <div
                    className={s.paymentOptionContainer}
                    style={{
                      border:
                        selectedOptionUuid === pm.uuid
                          ? `3px solid ${theme.palette.primary.light}`
                          : undefined
                    }}
                    onClick={this.selectPaymentOption.bind(this, pm.uuid)}
                  >
                    <div style={{ display: "flex", alignItems: "center" }}>
                      {selectedOptionUuid === pm.uuid ? (
                        <CheckBoxOutlined
                          style={{ color: theme.palette.primary.light }}
                        />
                      ) : (
                        <CheckBoxOutlineBlank />
                      )}

                      <div style={{ color: "#555", paddingLeft: 20 }}>
                        {pm.type}{" "}
                        <span style={{ color: "#888", fontSize: 10 }}>
                          ending in
                        </span>{" "}
                        {pm.last4}
                      </div>
                    </div>
                  </div>
                );
              })}
              {!showAddNewCard ? (
                <div
                  className={s.addNewCardContainer}
                  style={{ color: theme.palette.primary.dark }}
                  onClick={() => {
                    this.setState({ showAddNewCard: true });
                  }}
                >
                  add card
                </div>
              ) : null}
            </div>
            <div
              style={{
                overflowX: "scroll",
                width: !showAddNewCard ? 0 : undefined
              }}
            >
              <div className={s.newCardContainer}>
                <div className={s.newCardContainerTitle}>
                  New Card Information
                </div>
                <StripeProvider apiKey={config.stripe.key}>
                  <div className={s.cardDialog}>
                    <Elements>
                      <InjectedCardForm
                        user={user}
                        createPaymentOption={
                          this.context.global.createPaymentOption
                        }
                        closeDialog={() => {
                          //quick hack to clear the stripe entry
                          this.setState({ paymentOption: 2 });
                          this.setState({ paymentOption: 1 });

                          if (
                            this.context.global.data.user.account.paymentOptions
                              .length > 0
                          ) {
                            this.setState({
                              selectedOptionUuid: this.context.global.data.user
                                .account.paymentOptions[
                                this.context.global.data.user.account
                                  .paymentOptions.length - 1
                              ].uuid
                            });
                          }

                          this.setState({ showAddNewCard: false });
                        }}
                      />
                    </Elements>
                  </div>
                </StripeProvider>
              </div>
            </div>
          </div>
          <div style={{ marginTop: "1rem" }}>
            <Button
              disabled={
                this.state.email.length === 0 ||
                Object.keys(this.state.error).filter(k => this.state.error[k])
                  .length > 0
                  ? true
                  : undefined
              }
              fullWidth
              onClick={this.submit.bind(this)}
            >
              {loading ? (
                <CircularProgress style={{ height: 25, width: 25 }} />
              ) : (
                "Give Gift"
              )}
            </Button>
          </div>
        </Card>
      </div>
    );
  }
  x;
}

const styles = theme => ({
  popover: {
    margin: 10,
    overflow: "scroll",
    maxHeight: "70vh"
  }
});

export default withTheme()(withStyles(styles)(GiveGift));
